import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
import { SHAPE_STROKE_COLOR, HANDLE_TOLERANCE } from '../../constants';
export var Line = function (_a) {
    var _b = _a.definition, width = _b.width, strokeWidth = _b.strokeWidth;
    var PointerArea = useContext(ComponentContext).PointerArea;
    var SelectionMarker = useContext(ComponentContext).SelectionMarker;
    return (React.createElement(React.Fragment, null,
        React.createElement("line", { "data-not-bounding": true, x1: "0", y1: "0", x2: width, y2: "0", style: { stroke: SHAPE_STROKE_COLOR, strokeWidth: strokeWidth } }),
        React.createElement(PointerArea, { width: width, height: HANDLE_TOLERANCE * 2, y: -HANDLE_TOLERANCE }),
        React.createElement(SelectionMarker, { y: -HANDLE_TOLERANCE, width: width, height: HANDLE_TOLERANCE * 2 })));
};
//# sourceMappingURL=line.js.map